<template>
  <div class="newsbox">
    <div class="text1Head">
      <h3>{{detailData.title}}</h3>
      <h5>
        <span>{{detailData.release_time_text}}</span>
        <span>来源  :{{detailData.author}}</span>
        <a @click="goList"><img src="" alt="">返回列表 ></a>
      </h5>
    </div>
    <div class="dd">
      <span>导读</span>{{detailData.intro}}
    </div>
    <div class="p" v-html="detailData.content"></div>
  </div>
</template>

<script>
import { getnewsDetail } from '../../api/api.js'
import { ElMessage } from 'element-plus'

export default {
  props: ['id'],
  data () {
    return {
      detailData: {
        title: '',
        release_time_text: '',
        author: '',
        intro: '',
        content: ''
      }
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    async getDetail () {
      try {
        const res = await getnewsDetail(this.id)
        this.detailData = res.data
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    goList () {
      this.$emit('back')
    }
  }
}
</script>

<style scoped lang="scss">
.newsbox {
  padding: 70px 0 75px 0;
  text-align: center;
  width: 1200px;
  margin: auto;
  .text1Head {
    h3 {
      font-size: 36px;
      color: #3b585b;
      line-height: 42px;
      letter-spacing: 1px;
    }
    h5 {
      width: 100%;
      margin-top: 22px;
      font-size: 16px;
      color: #3b585b;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: center;
      span {
        margin-right: 20px;
        display: inline-block;
        vertical-align: top;
      }
      a {
        float: right;
        font-size: 16px;
        color: #3b585b;
        cursor: pointer;
        img {
          margin: -3px 10px 0 0;
          vertical-align: middle;
        }
      }
    }
  }
  .dd {
    text-align: left;
    margin-top: 36px;
    margin-bottom: 30px;
    background: #f4f1e7;
    padding: 35px 41px 46px 130px;
    position: relative;
    font-size: 16px;
    color: #3b585b;
    line-height: 30px;
    letter-spacing: 1px;
    overflow: hidden;
    display: block;
    span {
      display: block;
      position: absolute;
      left: 40px;
      top: 35px;
      font-size: 24px;
      color: #3b585b;
      width: 26px;
    }
    span:before {
      content: '';
      width: 1px;
      height: 56px;
      background: #dedede;
      position: absolute;
      right: -30px;
      top: 50%;
      margin-top: -28px;
    }
  }
}
</style>
